import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  // Replace these values with your actual Firebase project config
  // Get these from: Firebase Console > Project Settings > General > Your apps
  apiKey: "AIzaSyBHJLkNQ3a_H7syjU9zhiwz4k2egMHOLSo",
  authDomain: "tera-waiting-list.firebaseapp.com",
  projectId: "tera-waiting-list",
  storageBucket: "tera-waiting-list.firebasestorage.app",
  messagingSenderId: "1030046748205",
  appId: "1:1030046748205:web:d529dab5d0c09cf0f632a4",
  measurementId: "G-H6P21YNLSM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app; 